import { Plugin } from '@nuxt/types';

const plugin: Plugin = (context, inject) => {
  const apiLayout = { api: 'https://middleware.canifa.com/api/' };
  context.$api_layout = apiLayout;
  inject('api_layout', apiLayout);
};

export default plugin;